export const userInputs = [
  {
    code: 1,
    id: "name",
    label: "Full Name",
    type: "text",
    placeholder: "John Smith",
  },
  {
    code: 2,
    id: "username",
    label: "Username",
    type: "text",
    placeholder: "john_smith",
  },
  {
    code: 3,
    id: "email",
    label: "Email",
    type: "text",
    placeholder: "johnsmith@gmail.com",
  },
  {
    code: 4,
    id: "phone",
    label: "Phone number",
    type: "text",
    placeholder: "+65 87654321",
  },
  {
    code: 5,
    id: "password",
    label: "Password",
    type: "password",
    placeholder: "",
  },
  {
    code: 6,
    id: "address",
    label: "Address",
    type: "text",
    placeholder: "1 Orange Road",
  },
  {
    code: 7,
    id: "country",
    label: "Country",
    type: "text",
    placeholder: "Singapore",
  },
];

export const productInputs = [
  {
    code: 1,
    id: "name",
    label: "Name of Product",
    type: "text",
    placeholder: "Product A01",
  },

  {
    code: 2,
    id: "description",
    label: "Description",
    type: "text",
    placeholder: "Product A01",
  },
  {
    code: 3,
    id: "category",
    label: "Category",
    type: "text",
    placeholder: "Computers",
  },
  {
    code: 4,
    id: "price",
    label: "Unit Price ($)",
    type: "text",
    placeholder: "5.00",
  },
  {
    code: 5,
    id: "stock",
    label: "Available Stock",
    type: "number",
    placeholder: "50",
  },
];
